import { FC } from "react"
import { useNavigate } from "react-router-dom"

import { FormContainer } from "domain/core/containers/FormContainer"
import { FormModeEnum } from "domain/enums/FormModeEnum"

import { CreateThemeModal } from "view/pages/customization/CreateThemeModal"

import { validate } from "./validate"
import { ThemeEnum } from "../../types"

const initialValues = {
  name: "",
  [ThemeEnum.Light]: {
    primaryBackground: "#EBF0FB",
    secondaryBackground: "#FFFFFF",
    primaryColor: "#C9F73A",
    secondaryColor: "#346BD7",
    primaryTextColor: "#000000",
  },
  [ThemeEnum.Dark]: {
    primaryBackground: "#262626",
    secondaryBackground: "#1A1A1A",
    primaryColor: "#C9F73A",
    secondaryColor: "#C9F73A",
    primaryTextColor: "#000000",
  },
}

type TCreateThemeContainerProps = {
  onClose(): void
}

export const CreateThemeContainer: FC<TCreateThemeContainerProps> = ({
  onClose,
}) => {
  const navigate = useNavigate()

  const onSuccess = (data) => {
    const name = data?.styles?.[data?.styles.length - 1]?.name
    if (!name) return
    navigate(name)
  }

  return (
    <FormContainer
      mode={FormModeEnum.Add}
      url="/v1/merchants/styles"
      Form={CreateThemeModal}
      validate={validate}
      initialValues={initialValues}
      mapToReqModel={(data) => ({ styles: [data] })}
      formProps={{
        onClose,
        errorAlign: "center",
      }}
      cbSuccess={onSuccess}
    />
  )
}
